import { render, staticRenderFns } from "./AlertSuccess.vue?vue&type=template&id=a0b68104&scoped=true"
import script from "./AlertSuccess.vue?vue&type=script&lang=js"
export * from "./AlertSuccess.vue?vue&type=script&lang=js"
import style0 from "./AlertSuccess.vue?vue&type=style&index=0&id=a0b68104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b68104",
  null
  
)

export default component.exports